export default function extractOtpMessage(
  data: unknown,
  fallback: string
): string {
  if (data && typeof data === 'object') {
    const d = data as Record<string, unknown>
    const erro = d.error
    if (erro && typeof erro === 'object') {
      const m = (erro as Record<string, unknown>).message
      if (typeof m === 'string') return m
    }
    if (typeof d.message === 'string') return d.message
  }
  return fallback
}